import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function getTeethClassname(teeth) {
  const isUpper = teeth.teeth_id <= 16;
  return cn('wasm-ipr-item', {
    'wasm-ipr--upper': isUpper,
    'wasm-ipr--lower': !isUpper,
    'wasm-ipr--missing': teeth.missing,
    'wasm-ipr--no-ipr': !teeth.has_ipr,
  });
}

function getIprValueContainerClassname(distance) {
  const isIprNegative = distance < 0;
  return cn('wasm-ipr-value-container', {
    'wasm-ipr-value-container--ipr': isIprNegative,
    'wasm-ipr-value-container--spacing': !isIprNegative,
  });
}

// Fallback for legacy IPR data that has no wasm-provided label
function formatIprLabel(distance) {
  const absIpr = Math.abs(distance);
  const rounded = `${Math.round(absIpr * 10) / 10}`;
  return absIpr >= 1 ? rounded : rounded.slice(1);
}

function IPRValue({ ipr, hasIpr }) {
  if (!ipr || !hasIpr) {
    return null;
  }

  const { distance, label } = ipr;
  const displayedIpr = label || formatIprLabel(distance);
  if (!displayedIpr) {
    return null;
  }

  return (
    <span className={getIprValueContainerClassname(distance)}>
      <span className="wasm-ipr-value">{displayedIpr}</span>
    </span>
  );
}

IPRValue.propTypes = {
  ipr: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      distance: PropTypes.number,
      label: PropTypes.string,
    }),
  ]).isRequired,
  hasIpr: PropTypes.bool.isRequired,
};

function WasmIPRItem(props) {
  const { teeth, info } = props;

  return (
    <div className={getTeethClassname(info)}>
      {teeth}
      <IPRValue ipr={info.ipr} hasIpr={info.has_ipr} />
    </div>
  );
}

WasmIPRItem.propTypes = {
  teeth: PropTypes.string.isRequired,
  info: PropTypes.shape({
    teeth_ipr: PropTypes.number,
    ipr: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        distance: PropTypes.number,
        label: PropTypes.string,
      }),
    ]),
    missing: PropTypes.bool,
    has_ipr: PropTypes.bool,
  }).isRequired,
};

export default WasmIPRItem;
